module.exports = __webpack_public_path__ + "static/media/reportsnewimage.a2b6e34d.png";